module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Irish Comparison Site. Never overpay on a bill again!"}}')
  delete Component.options._Ctor
}
